import { render, staticRenderFns } from "./SurveyEnd.vue?vue&type=template&id=2db228b1&scoped=true&"
import script from "./SurveyEnd.vue?vue&type=script&lang=js&"
export * from "./SurveyEnd.vue?vue&type=script&lang=js&"
import style0 from "./SurveyEnd.vue?vue&type=style&index=0&id=2db228b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db228b1",
  null
  
)

export default component.exports